import React from 'react'
import { useState } from 'react'
import MyButton from '../../../../UI/form/MyButton'
import MyModal from '../../../../UI/modal/MyModal'
import AddCardIcon from '@mui/icons-material/AddCard';
import SendToPayForm from './SendToPayForm';

const SendToPayButton = () => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <MyButton
            onClick={e => setOpen(true)}
        >
            <AddCardIcon />
        </MyButton>

        <MyModal
            classNameAdd='supplyOrderModal'
            open={open}
            setOpen={setOpen}
            header={'Зміна статусу оплати'}
            disableClickOutside={true}
            content={
                <SendToPayForm
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default SendToPayButton